import config from 'src/shared/config';
import { clearCreditsAlertDismiss } from './creditsAlert';

export const Logout = ({ invalidateRelayStore, fromPricing }: { invalidateRelayStore: () => void; fromPricing?: boolean }) => {
    // For Users logged with googlelogin
    if ((window as any).gapi) {
        const _gapi = (window as any).gapi;
        if (_gapi && _gapi.auth2) {
            let auth2 = _gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        }
    }

    clearCreditsAlertDismiss();
    invalidateRelayStore();

    var f = document.createElement('form');

    document.body.appendChild(f);
    f.action = fromPricing ? `${config.baseUrl}Auth/Logout?frompricing=true` : `${config.baseUrl}Auth/Logout`;
    f.method = 'POST';

    f.submit();
};
